import { render, staticRenderFns } from "./ketogenesis4.vue?vue&type=template&id=6cf57517&scoped=true&"
import script from "./ketogenesis4.vue?vue&type=script&lang=js&"
export * from "./ketogenesis4.vue?vue&type=script&lang=js&"
import style0 from "./ketogenesis4.vue?vue&type=style&index=0&id=6cf57517&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf57517",
  null
  
)

export default component.exports